import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import moment from 'moment';
import SessionStore from 'stores/shared/session';
import { t, loadLocales } from 'services/translation';
import Immutable from 'immutable';
import _ from 'underscore';
import Transitionable from 'mixins/transitionable';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import { isStripeFieldsCompleted } from 'lib/form/stripe_fields';
import PricingStore from 'stores/plugins/pricing';
import BookingRequestStore from 'stores/plugins/booking_request';
import TourAvailabilityActionCreator from 'action_creators/tour_availability';
import TourAvailabilityService from 'services/tour_availability';
import FormController from 'lib/form/controller';
import { TimingValidations } from 'views/plugins/booking_request/validations/timing';
import CheckoutValidations from 'views/plugins/booking_request/validations/checkout';
import Dimmer from 'views/shared/ui/dimmer';
import BookingRequestActionCreator from 'action_creators/booking_request';
import PricingActionCreator from 'action_creators/pricing';
import ModalActionCreator from 'action_creators/modal';
import { CheckoutError } from 'views/plugins/global_error/CheckoutError';
import { addonsWithPrices } from 'lib/pricing_utils';
import { formatBookerGuestName } from 'views/plugins/checkout/guest_information/Helpers';
import styled from '@emotion/styled';
import PoweredBy from '../powered_by';
import { formatAdditionalGuests } from './helpers';
import CheckoutTimer from '../checkoutTimer';
import { isGuestOnList } from '../api';
import { getSupportEmail } from '../helpers';
import { sendEventToSegment } from 'views/anyguide/helpers/analytics/segmentHelpers';
import { getSessionId } from 'views/plugins/tours/page/booking_details/Helpers';

const StyledTimer = styled(CheckoutTimer)`
  margin: 16px 24px ${(props) => props.marginBottom ?? '0px'} 24px;
  font-size: 13px;
`;

const CheckoutNavigationController = createReactClass({
  displayName: 'CheckoutNavigationController',
  mixins: [StoreInterestMixin, Transitionable, FormController],

  screenTransitionTime: 700,

  propTypes: {
    addons: PropTypes.array,
    available_dates: PropTypes.object.isRequired,
    can_be_paid_in_cash: PropTypes.bool,
    is_guest_of_guest_enabled: PropTypes.bool,
    date_picker_type: PropTypes.string.isRequired,
    guide_us_only: PropTypes.bool,
    phone_mandatory: PropTypes.bool,
    includes_transport: PropTypes.bool,
    partner_info: PropTypes.object,
    initial_fields: PropTypes.object.isRequired,
    initial_fully_discounted: PropTypes.bool.isRequired,
    initial_price_fields: PropTypes.object.isRequired,
    initial_summary_props: PropTypes.object.isRequired,
    max_people: PropTypes.number.isRequired,
    min_people: PropTypes.number.isRequired,
    price_props: PropTypes.object,
    show_dates: PropTypes.bool,
    tour_id: PropTypes.number.isRequired,
    tour_settings: PropTypes.object,
    unit_types: PropTypes.array,
    unitPrices: PropTypes.object,
    zero_priced_tour: PropTypes.bool.isRequired,
    field_requirements_subtext: PropTypes.string,
    is_ga4_enabled: PropTypes.bool,
    unitPriceForInitialPricing: PropTypes.object,
    totalWithoutServiceFee: PropTypes.number,
    units_and_addons_detail: PropTypes.array,
    waitlist_details: PropTypes.object,
    initial_ticket_quantity: PropTypes.number.isRequired,
    has_ticket_capacity_enabled: PropTypes.bool,
    sold_out_link_text: PropTypes.string,
    ticket_capacities_details: PropTypes.array,
  },

  getInitialState() {
    return _.extend(
      {
        addonAvailability: Immutable.fromJS({}),
        addonsPrices: [],
        availableDates: Immutable.fromJS({}),
        availableTimes: Immutable.fromJS({}),
        booking_request_id: this.props.initial_fields.id,
        cashTotal: 0,
        committed: false,
        errors: Immutable.Map({}),
        fields: Immutable.Map(this.props.initial_fields),
        for_invoice: this.props.for_invoice,
        invoiceable: this.props.invoiceable,
        fully_discounted: this.props.initial_fully_discounted,
        guide_us_only: this.props.guide_us_only,
        phone_mandatory: this.props.phone_mandatory,
        initialTotal: 0,
        loading: false,
        priceFields: Immutable.Map(this.props.initial_price_fields),
        saved: false,
        showDates: this.props.show_dates,
        summary_props: Immutable.Map(this.props.initial_summary_props),
        total: 1, // So that billing section doesn't flicker on mount
        tourDates: Immutable.fromJS(this.props.available_dates),
        fsUnsent: true,
        loadingDates: false,
        stripe: { fieldsCompleted: [] },
        ticketUnits: [],
        bookerUnitId: null,
        isPayLaterSelected: false,
        selectedPaymentType: '',
        bookerUnitTypeChanged: false,
        slotTicketCapacities: [],
        timeSelected: false,
        tourTicketCapacities: [],
        capacityError: null,
        capacityErrorCleared: false,
        trackedCheckouts: new Set(),
      },
      this.transitionableInitialState()
    );
  },

  getStoreInterests() {
    return _.extend(
      {
        addonAvailability: 'tour_availability.addon_availability',
        addonPrices: 'pricing.addons',
        availabilityFiltered: 'tour_availability.filtered',
        availableDates: 'tour_availability.availableDates',
        availableTimes: 'tour_availability.availableTimes',
        loadingDates: 'tour_availability.isLoading',
        booking_request_id: 'booking_request.booking_request_id',
        cashTotal: 'pricing.cash_total_formatted',
        discountApplied: 'booking_request.discountApplied',
        discountCode: 'booking_request.discount_code',
        discountLoading: 'booking_request.discountLoading',
        errors: 'booking_request.errors',
        fully_discounted: 'booking_request.fully_discounted',
        guide_us_only: 'booking_request.guide_us_only',
        phone_mandatory: 'booking_request.phone_mandatory',
        loading: 'booking_request.loading',
        onlineTotal: 'pricing.online_total_formatted',
        paid_in_cash: 'booking_request.paid_in_cash',
        privacy_policy_link: 'pricing.privacy_policy_link',
        privacy_policy_link_text: 'pricing.privacy_policy_link_text',
        hide_policy_links: 'pricing.hide_policy_links',
        showDates: 'booking_details.showDates',
        summary_props: 'booking_request.summary_props',
        total: 'pricing.total',
        tourDates: 'tour_availability.dates',
        unitPrices: 'pricing.units',
        zero_priced_tour: 'pricing.zero_priced',
        currency: 'pricing.currency',
        stripeToken: 'booking_request.stripeToken',
        customerSecret: 'booking_request.customerSecret',
        stripeCardElement: 'booking_request.stripeCardElement',
        requiresAuth: 'booking_request.requiresAuth',
        authCompleted: 'booking_request.authCompleted',
        paymentId: 'booking_request.paymentId',
        managedAccountToken: 'booking_request.managedAccountToken',
        createdAt: 'booking_request.createdAt',
        isOutsidePayLaterCutoff: 'booking_request.isOutsidePayLaterCutoff',
        willExpireOn: 'booking_request.willExpireOn',
        unitPriceForInitialPricing: 'pricing.unit_price_for_initial_pricing',
        totalWithoutServiceFee: 'pricing.total_without_service_fee',
        units_and_addons_detail: 'pricing.units_and_addons_detail',
      },
      this.transitionableStoreInterests()
    );
  },

  getDefaultProps() {
    return {
      can_be_paid_in_cash: false,
      includes_transport: false,
      initialScreen: {
        component: 'Views.Plugins.Checkout.Mobile.Screens.BookingInitial',
        props: {},
      },
      tour_properties: {},
    };
  },

  UNSAFE_componentWillMount() {
    loadLocales(SessionStore.state.get('i18n'));
  },

  componentDidMount() {
    const isInIframe = window !== window.top;
    const {
      is_booking_invoice,
      tour_id,
      tour: { guide_id },
      initial_fields: { origin_url },
    } = this.props;

    BookingRequestStore.changed.add(this._bookingRequestChanged);
    this._availabilityChanged();
    PricingStore.changed.add(this._pricingChanged);
    BookingRequestStore.changed.add(this._refreshPricing);
  },

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.errors.equals(this.state.errors)) {
      this._processCapacityErrors();
    }

    // No lingering errors for the BookingInitial form
    if (this._hasBookingInitialErrors()) {
      this.setState({
        errors: Immutable.Map(
          _.omit.apply(
            null,
            _.union(
              [this.state.errors.toJS()],
              this.formSections.BookingInitial
            )
          )
        ),
      });
    }

    if (!this.state.tourDates.equals(prevState.tourDates)) {
      this._availabilityChanged();
    }

    const {
      booking_request_id: bookingRequestId,
      tour_id: tourId,
      trackedCheckouts,
    } = this.state;

    const {
      tour: { guide_id: guideId, guide_name: guideName },
    } = this.props;
    if (bookingRequestId && !trackedCheckouts.has(bookingRequestId)) {
      this.setState((prevState) => ({
        trackedCheckouts: new Set(prevState.trackedCheckouts).add(
          bookingRequestId
        ),
      }));
      try {
        sendEventToSegment('Checkout Started', {
          path: window.location.hash || window.location.pathname,
          referrer: document.referrer,
          session_id: getSessionId(),
          page_name: 'Checkout Started',
          url: window.location.href,
          experience_id: tourId,
          account_id: guideId,
          account_name: guideName,
          device: 'mobile',
        });
      } catch (error) {
        console.log('segment tracking error', error);
      }
    }
  },

  componentWillUnmount() {
    BookingRequestStore.changed.remove(this._bookingRequestChanged);
    BookingRequestStore.changed.remove(this._refreshPricing);
    PricingStore.changed.remove(this._pricingChanged);
  },
  renderTimer(styles) {
    const { willExpireOn } = this.state;
    const {
      is_booking_invoice,
      tour_id,
      tour: { guide_id },
    } = this.props;
    if (is_booking_invoice) return;
    return (
      <StyledTimer
        {...styles}
        sessionExpired={willExpireOn}
        tourId={tour_id}
        guideId={guide_id}
        originUrl={this.props.initial_fields.origin_url}
      />
    );
  },
  _getDate() {
    let date = this.state.fields.get('date');
    if (
      this.state.availabilityFiltered &&
      date &&
      this.state.availableDates.toJS()[date] === undefined
    ) {
      date = null;
    }
    return date;
  },

  _getTime() {
    let time = this.state.fields.get('time');
    if (this._getDate() === null) {
      time = null;
    }
    return time;
  },

  _loadCardHolderInfo() {
    let fields = this.state.fields.set(
      'cardholder_first_name',
      this.state.fields.get('first_name')
    );
    fields = fields.set(
      'cardholder_last_name',
      this.state.fields.get('last_name')
    );

    this.setState({
      fields,
    });
  },

  _clearCapacityErrors() {
    const { capacityError } = this.state;
    this.setState({
      capacityError: null,
      capacityErrorCleared: true,
    });
  },

  _resetCapacityErrorFlag() {
    this.setState({ capacityErrorCleared: false });
  },

  _processCapacityErrors() {
    const errorObject = this.state.errors.toJS();
    const { capacityErrorCleared, capacityError } = this.state;

    if (
      !_.isEmpty(errorObject) &&
      !capacityErrorCleared &&
      errorObject.hasOwnProperty('ticket-capacity') &&
      capacityError !== errorObject['ticket-capacity']
    ) {
      this.setState({
        capacityError: errorObject['ticket-capacity'],
      });
    }
  },

  _pricingChanged() {
    const { bookerUnitId, bookerUnitTypeChanged } = this.state;
    const units = PricingStore.state.get('units').toJS().items;
    const bookerUnit = units?.find((unit) => unit.count > 0);
    const bookerPricingId = bookerUnitTypeChanged
      ? bookerUnitId
      : bookerUnit?.id;
    this.setState({
      total: parseFloat(PricingStore.state.get('total')),
      ticketUnits: units,
      bookerUnitId: bookerPricingId,
    });
  },

  _refreshPricing() {
    PricingActionCreator.preview();
  },
  _fetchSlotCapacities(tourPublicId, date, time) {
    TourAvailabilityService.getSlotTicketCapacities(tourPublicId, date, time)
      .then((response) => {
        const data = response.data;
        if (data.slotTicketCapacities) {
          const now = new Date();
          this.setState(
            {
              slotTicketCapacities: data.slotTicketCapacities,
            },
            () => {
              this.forceUpdate();
            }
          );
        }
      })
      .catch((error) => {
        console.error('Error fetching slot capacities:', error);
      });
  },

  _additionalGuestInputChanged(position, value, nameField, unitTypeId) {
    if (position === 'bookerUnitId') {
      this.setState({ bookerUnitId: value, bookerUnitTypeChanged: true });
      return;
    }
    const stateFields = this.state.fields.toJS();
    const additionalGuests = stateFields.additional_guests;
    const numOfAdditionalGuests = this.getNumGuests() - 1;
    if (numOfAdditionalGuests !== additionalGuests.length) {
      additionalGuests.splice(numOfAdditionalGuests);
    }
    let guest = additionalGuests.find((g) => g.position === position);

    if (typeof guest === 'undefined') {
      guest = { [nameField]: value, position, unit_type_id: unitTypeId };
      additionalGuests.push(guest);
    } else {
      guest[nameField] = value;
      guest.unit_type_id = unitTypeId;
    }
    this.setState({ fields: Immutable.Map(stateFields) });
  },

  _hasBookingInitialErrors() {
    const _this = this;
    return !!_.find(this.formSections.BookingInitial, (field) =>
      _this.state.errors.has(field)
    );
  },

  _finishedLoading(prevState) {
    return this.state.loading === false && prevState.loading === true;
  },

  formSections: {
    BookingInitial: ['units', 'date', 'time', 'location_id', 'time_zone'],
    BookingAddons: ['addons'],
    CheckoutPersonal: ['first_name', 'last_name', 'email', 'phone'],
    CheckoutPayment: [
      'cardholder_first_name',
      'cardholder_last_name',
      'cardNumber',
      'cardExpiry',
      'cardCvc',
      'billing_address_line_1',
      'billing_address_line_2',
      'billing_country',
      'billing_city',
      'billing_region',
      'billing_zip_code',
      'postalCode',
    ],
    AdditionalInformation: [
      'waiver_accepted',
      'checkout_questions',
      'additional_guests',
    ],
    CheckoutSummary: ['message', 'privacy_policy_accepted'],
  },

  validationConstraints() {
    const { is_affiliate: isAffiliate } = this.props;
    const validations = _.extend({}, TimingValidations);
    if (this._shouldSkipPayment()) {
      _.extend(
        validations,
        _.omit.apply(
          null,
          _.union([CheckoutValidations], this.formSections.CheckoutPayment)
        )
      );
    } else {
      _.extend(validations, CheckoutValidations);
    }

    if (!this._shouldShowWaiver()) {
      // Don't validate waiver if it is not enabled
      _.extend(validations, { waiver_accepted: {} });
    }

    if (!this._shouldShowQuestions()) {
      _.extend(validations, { checkout_questions: {} });
    }

    if (!this._shouldValidatePrivacyPolicy()) {
      // Don't validate guide privacy policy if not present
      _.extend(validations, { privacy_policy_accepted: {} });
    }

    if (!this._shouldValidatePhone()) {
      // Don't validate phone if not enabled
      _.extend(validations, { phone: {} });
    }

    if (this.props.tour.multiple_locations) {
      _.extend(validations, {
        location_id: {
          presence: true,
        },
      });
    }

    if (isAffiliate) {
      _.extend(validations, { email: {} });
    }

    if (!this._shouldShowPersonalSection()) {
      // Don't validate personal information if it is hidden
      _.extend(validations, {
        first_name: {},
        last_name: {},
        email: {},
        phone: {},
      });
    }

    return validations;
  },

  _shouldShowWaiver() {
    const { is_affiliate: isAffiliate } = this.props;
    return !isAffiliate && this.props.tour.tour_waiver_info.required;
  },

  _shouldValidatePrivacyPolicy() {
    return (
      this.state.privacy_policy_link && this.state.privacy_policy_link_text
    );
  },

  _shouldValidatePhone() {
    return this.props.phone_mandatory;
  },

  _shouldShowQuestions() {
    const checkoutQuestions = this.props.initial_fields.checkout_questions;
    return checkoutQuestions && !!checkoutQuestions.length;
  },

  _shouldShowAdditionalInfo() {
    return this._shouldShowWaiver() || this._shouldShowQuestions();
  },

  _shouldCollectGuestInfo() {
    const {
      is_guest_of_guest_enabled,
      guest_of_guest_max_guests,
      is_affiliate,
    } = this.props;
    const ignoreMaxGuest =
      guest_of_guest_max_guests === 0
        ? true
        : this.getNumGuests() <= guest_of_guest_max_guests;
    return (
      !is_affiliate &&
      is_guest_of_guest_enabled &&
      this.getNumGuests() > 1 &&
      ignoreMaxGuest
    );
  },

  _shouldShowPersonalSection() {
    return this.props.is_guest_info_collection_enabled;
  },

  _shouldSkipPayment() {
    const { total, paid_in_cash, isPayLaterSelected } = this.state;

    return total === 0 || paid_in_cash || isPayLaterSelected;
  },

  _shouldShowPayLater() {
    const { zero_priced_tour } = this.state;
    const { is_pay_later_enabled } = this.props;

    return (
      zero_priced_tour !== null && !zero_priced_tour && is_pay_later_enabled
    );
  },

  _bookingRequestProps() {
    return this.state.summary_props.get('request') || {};
  },

  // Either a regular invoice or a booking invoice that is a direct link shared w guest
  _paymentOnlyFlow() {
    return (
      this._bookingRequestProps().is_invoice ||
      this._bookingRequestProps().invoiceable
    );
  },

  _fieldsToHide() {
    const fieldsToHide = [];
    const { initial_fields } = this.props;
    if (this._paymentOnlyFlow() && initial_fields.email) {
      // check for email here
      fieldsToHide.push('email');
    }
    if (this._paymentOnlyFlow()) {
      fieldsToHide.push('name');
    }
    return fieldsToHide;
  },

  onValidationErrors() {
    this._committing = false;
  },

  _additionalSubmitParams() {
    return {
      units: this.state.fields.get('units'),
      tour_id: this.props.tour_id,
      id: this.state.booking_request_id || this.props.initial_fields.id,
      context: this.props.initial_fields.context,
      origin_url: this.props.initial_fields.origin_url,
      location_id: this.state.fields.get('location_id'),
      addon_configuration: this.state.fields.get('addons'),
      unit_configuration: this.state.fields.get('units'),
    };
  },

  async validateGuest(params) {
    const { email } = params;
    const { tour_id: tourId } = this.props;
    const guestAllowed = await isGuestOnList(tourId, email);

    if (guestAllowed) {
      this.submitForm(params);
    } else {
      this.setState((prevState) => ({
        errors: prevState.errors.set(
          'email',
          Immutable.List.of(t('RESTRICTED_BOOKING_EMAIL_ERROR'))
        ),
      }));
    }
  },

  async formSubmitted(params) {
    this._resetCapacityErrorFlag();

    const {
      is_rsvp_enabled: isRsvpEnabled,
      is_booking_invoice: isBookingInvoice,
      has_ticket_capacity_enabled: hasTicketCapacityEnabled,
      tour_public_id: tourPublicId,
    } = this.props;

    if (hasTicketCapacityEnabled && this._getDate() && this._getTime()) {
      this._fetchSlotCapacities(tourPublicId, this._getDate(), this._getTime());
    }
    const activeScreen = this.state.activeScreen.toJS().component;
    const checkoutPersonal =
      this._getActiveScreen(activeScreen) === 'CheckoutPersonal';
    if (isRsvpEnabled && !isBookingInvoice && checkoutPersonal) {
      this.validateGuest(params);
    } else {
      this.submitForm(params);
    }
  },

  async submitForm(params) {
    const { isPayLaterSelected } = this.state;
    if (params.checkout_questions && !isPayLaterSelected) {
      params.checkout_questions.forEach((question) => {
        if (
          question.input_type === 'date' &&
          question.answer?.indexOf('-') > -1
        ) {
          // handle android mobile dates
          const splitArray = question.answer.split('-');
          const normalizedDate = `${splitArray[1]}/${splitArray[2]}/${splitArray[0]}`;
          question.answer = normalizedDate;
        }
      });
      params.checkout_questions = this._flattenMultipleCheckoutAnswers(
        params.checkout_questions
      );
    }

    const activeScreen = this.state.activeScreen.toJS().component;
    if (activeScreen && activeScreen.split('.').pop() !== 'BookingInitial') {
      delete params.location_id;
    } else {
      // should use updated booker unit id and not the one from state
      this.setState({ bookerUnitTypeChanged: false });
    }

    if (params.additional_guests) {
      params.additional_guests = formatAdditionalGuests(
        params.additional_guests
      ); // Remove when we transition to guest of guest api
    }

    params.booker_unit_id = this.state.bookerUnitId;

    const { fieldsCompleted = [] } = this.state.stripe || {};

    // Stripe token API call is only available when the element is mounted on the DOM
    const stripeElementMounted = document.querySelector('.StripeElement');

    // Creates token for stripe to ensure most recent card details are used
    if (stripeElementMounted && isStripeFieldsCompleted(fieldsCompleted)) {
      await stripe.createToken(this.state.stripeCardElement).then((result) => {
        const { stripe } = this.state;
        if (result.token) {
          BookingRequestActionCreator.setStripeToken(result.token.id);
          this.setState({
            stripe: {
              ...stripe,
              token: result.token.id,
            },
          });
        } else if (result.error) {
          this.setState({
            stripe: {
              ...stripe,
              error: result.error,
            },
          });
        }
      });
    }

    if (this._committing === true) {
      this._committing = false;
      BookingRequestActionCreator.commit({
        ...params,
        stripe_token: this.state.stripeToken,
      });
      // BookingRequestActionCreator.commit(params);
    } else {
      BookingRequestActionCreator.save({
        ...params,
        stripe_token: this.state.stripeToken,
      });
    }
  },

  _getActiveScreen(activeScreen) {
    return (
      activeScreen &&
      typeof activeScreen === 'string' &&
      activeScreen.split('.').pop()
    );
  },

  _flattenMultipleCheckoutAnswers(checkout_questions) {
    // we are only permitting the tour_question_id and answers on the backend
    const answers = [];

    checkout_questions.forEach((question) => {
      if (Array.isArray(question.answer)) {
        question.answer.forEach((answer) => {
          const singleAnswer = {
            tour_question_id: question.tour_question_id,
            answer,
          };
          answers.push(singleAnswer);
        });
      } else {
        answers.push({
          tour_question_id: question.tour_question_id,
          answer: question.answer,
        });
      }
    });
    return answers;
  },

  _fetchSummary() {
    if (this.state.booking_request_id) {
      BookingRequestActionCreator.fetchSummary(this.state.booking_request_id);
    }
  },

  onCommit(e) {
    // Kinda hacky but yeah... I don't see a clean way
    // to do this right now.
    this._committing = true;
    this.onSubmit(e);
  },

  onFieldChanged: {
    date: '_handleDateChanged',
    time: '_handleTimeChanged',
    addons: '_handleAddonsChanged',
    units: '_handleUnitsChanged',
    time_zone: '_handleTimeZoneChanged',
  },

  _bookingRequestChanged() {
    const saved = BookingRequestStore.state.get('saved');
    const committed = BookingRequestStore.state.get('committed');

    if (
      (saved && this.state.saved !== saved) ||
      (committed && this.state.committed !== committed)
    ) {
      this._fetchSummary();
    }
    this.setState({ saved, committed });
  },

  _availabilityChanged() {
    TourAvailabilityActionCreator.filterDates(
      this.state.fields.get('guests'),
      this._getDate()
    );
  },

  setDateTime({ date, time }) {
    this.setState({
      fields: this.state.fields.set('date', date).set('time', time),
    });
  },

  setGuestTimezone({ timezone }) {
    this.setState({
      fields: this.state.fields.set('time_zone', timezone),
    });
  },

  clearTime() {
    this.setState({
      fields: this.state.fields.set('time', null),
    });
  },

  _handleDateChanged(newValue) {
    const { has_ticket_capacity_enabled: hasTicketCapacityEnabled } =
      this.props;
    if (hasTicketCapacityEnabled) {
      this._clearCapacityData();
    }

    const newDateKey = this._getDate();
    const newDateTimes = this.state.availableDates.toJS()[newDateKey];
    const currentTime = this._getTime();
    const guests = this.state.fields.get('guests');

    const shouldClearTime =
      newDateTimes &&
      currentTime &&
      (!_.has(newDateTimes, currentTime) || newDateTimes[currentTime] < guests);

    if (shouldClearTime) {
      this.setState({
        fields: this.state.fields.set('time', null),
      });
    }

    this._bookingDetailsChanged();
    this._availabilityChanged();
  },

  _clearCapacityData() {
    this.setState({
      capacityError: null,
      capacityErrorCleared: false, // Reset flag so new errors can be processed
      slotTicketCapacities: [],
    });
  },

  _handleTimeChanged(newTime) {
    this._bookingDetailsChanged();

    const {
      has_ticket_capacity_enabled: hasTicketCapacityEnabled,
      tour_public_id: tourPublicId,
    } = this.props;

    if (hasTicketCapacityEnabled) {
      this._clearCapacityData();
    }

    const date = this._getDate();
    const time = newTime;

    if (hasTicketCapacityEnabled) {
      this._fetchSlotCapacities(tourPublicId, date, time);
    }
  },

  _handleAddonsChanged(newAddons) {
    this._bookingDetailsChanged();
  },

  _handleUnitsChanged(newUnits) {
    if (!newUnits) {
      return null;
    }

    // Clear capacity error when user changes ticket selection
    this._clearCapacityErrors();

    this.setState({ units: newUnits });
    this.state.fields.set('units', newUnits);

    const totalCount = newUnits.reduce((a, e) => a + e.count, 0);
    const addons = _.clone(this.state.fields.get('addons'));
    const richAddons = this.props.addons;
    const newAddons = _.map(addons, (addon) => {
      // emprically seeing that addon.guests is NaN, don't have time to
      // trace back and figure out why, though it's prob not intentional.
      addon.guests = isNaN(addon.guests)
        ? totalCount
        : Math.min(addon.guests, totalCount);
      const richAddon = _.find(richAddons, (a) => a.id == addon.id);
      if (richAddon && !richAddon.independent_qty && richAddon.per_person) {
        addon.count = totalCount;
      }
      return addon;
    });
    this.setState({
      fields: this.state.fields.set('addons', newAddons),
    });
    const guestCount = newUnits.reduce((a, b) => a + b.count, 0);
    this.setState(
      {
        fields: this.state.fields.set('guests', guestCount),
      },
      () => {
        this._bookingDetailsChanged();
        if (!this._tooManyGuests()) {
          this._availabilityChanged();
        }
      }
    );
  },

  _handleTimeZoneChanged() {
    this._bookingDetailsChanged();
  },

  _bookingDetailsChanged() {
    BookingRequestActionCreator.change(this.state.fields.toJS());
  },

  _checkoutQuestionInputChanged(position, value) {
    const stateFields = this.state.fields.toJS();
    const checkoutQuestions = stateFields.checkout_questions;
    const question = checkoutQuestions.find(
      (answer) => answer.position === position
    );
    question.answer = value;
    this.setState({ fields: Immutable.Map(stateFields) });
  },

  _tooManyGuests() {
    const totalCount = this.state.fields
      .get('units')
      .reduce((a, b) => a + b.count, 0);
    const { min_people, max_people } = this.props;

    return totalCount < min_people || totalCount > max_people;
  },

  propsForBookingInitial() {
    const {
      availableDates,
      availableTimes,
      currency,
      errors,
      fields,
      loadingDates,
      priceFields,
      total,
      total_without_service_fee,
      tourDates,
      units,
      unit_price_for_initial_pricing,
    } = this.state;
    const { partner_info } = this.props;
    const brandColor = partner_info?.integration_brand_color;
    return {
      asynchronous_calendar: this.props.asynchronous_calendar,
      brandColor,
      min_people: this.props.min_people,
      max_people: this.props.max_people,
      availableDates: availableDates.toJS(),
      availableTimes: availableTimes.toJS(),
      initialDatesCount: Object.keys(tourDates.toJS()).length,
      date_picker_type: this.props.date_picker_type,
      is_recurrent: this.props.is_recurrent,
      showDates: this.props.show_dates,
      priceProps: priceFields.toJS(),
      hasAddons: this.props.addons.length > 0,
      origin_url: fields.get('origin_url'),
      unitTypes: this.props.unit_types,
      unitPrices: this.gracefulUnitPrices(),
      units: units,
      total: total,
      weekStartDay: this.props.week_start_day,
      isoTime: this.props.iso_time,
      has_resource: this.props.has_resource,
      resource_name: this.props.resource_name,
      loadAPIDates: this.loadAPIDates,
      loadingDates: loadingDates,
      setDateTime: this.setDateTime,
      setGuestTimezone: this.setGuestTimezone,
      clearTime: this.clearTime,
      availableDatetimes: this.props.available_datetimes,
      _tooManyGuests: this._tooManyGuests,
      addons: this.props.addons,
      showPersonalSection: this._shouldShowPersonalSection(),
      currency: currency,
      unitPriceForInitialPricing: unit_price_for_initial_pricing,
      totalWithoutServiceFee: total_without_service_fee,
      errors: errors,
      slotTicketCapacities: this.state.slotTicketCapacities,
      timeSelected: !!this._getTime(),
      tourTicketCapacities: this.props.ticket_capacities_details,
      capacityErrorCleared: this.state.capacityErrorCleared,
      sbpEnabled: this.props.sbp_enabled,
    };
  },

  gracefulUnitPrices() {
    let unitPrices = {};
    if (!!this.state.unitPrices && !!this.state.unitPrices.toJS) {
      unitPrices = this.state.unitPrices.toJS();
    }
    return unitPrices;
  },

  addonsWithPricing() {
    const pricingAddons = this.state.addonPrices.size
      ? this.state.addonPrices.get('items').toJS()
      : [];
    return addonsWithPrices(this.props.addons, pricingAddons);
  },

  getNumGuests() {
    let guests = 1;
    if (this.state && this.state.units) {
      guests = this.state.units.reduce((a, e) => a + e.count, 0);
    }
    return guests;
  },

  propsForBookingAddons() {
    return {
      guests: this.getNumGuests(),
      addons: this.addonsWithPricing(),
      addonAvailability: this.state.addonAvailability.toJS(),
      date: this._getDate(),
      time: this.state.fields.get('time'),
      tour_timezone: this.props.tour.tour_timezone,
      priceProps: _.extend({}, this.state.priceFields.toJS(), {
        calculated: true,
        selected_addons: this.state.fields.get('addons'),
      }),
      showPersonalSection: this._shouldShowPersonalSection(),
      skipPayment: this._shouldSkipPayment(),
      shouldShowAdditionalInformation: this._shouldShowAdditionalInfo(),
    };
  },

  propsForCheckoutPayment() {
    return {
      fully_discounted: this.state.fully_discounted,
      zero_priced_tour: this.state.zero_priced_tour,
      guide_us_only: this.props.guide_us_only,
      total: this.state.total,
      discount_props: {
        additionalParams: _.pick(
          this._additionalSubmitParams(),
          'tour_id',
          'id'
        ),
        errors: this.state.errors.get('discount_code'),
        discountApplied:
          this.state.discountApplied || PricingStore.state.get('discount') > 0,
        discountLoading: this.state.discountLoading,
        discountCode: this.state.discountCode,
        theme: 'mobile',
      },
      priceProps: _.extend({}, this.state.priceFields.toJS(), {
        calculated: true,
        selected_addons: this.state.fields.get('addons'),
      }),
      is_booking_invoice: this.props.is_booking_invoice,
      managedAccountToken: this.state.managedAccountToken,
      stripeTheme: this.props.stripe_theme,
      loadCardHolderInfo: this._loadCardHolderInfo,
      timer: this.renderTimer(),
      isPayLaterSelected: this.state.isPayLaterSelected,
      selectedPaymentType: this.state.selectedPaymentType,
      onSelectPaymentType: this._onSelectPaymentType,
      setInitialPaymentType: this._setInitialPaymentType,
      paymentSubtext: this._paymentSubtext(),
      shouldShowPayLater: this._shouldShowPayLater(),
      isOutsidePayLaterCutoff: this.state.isOutsidePayLaterCutoff,
    };
  },

  propsForAdditionalInformation() {
    return {
      priceProps: _.extend({}, this.state.priceFields.toJS(), {
        calculated: true,
        selected_addons: this.state.fields.get('addons'),
      }),
      questionsProps: {
        questions: this.props.initial_fields.checkout_questions,
        onChange: this._checkoutQuestionInputChanged,
      },
      privacy_policy_link: this.state.privacy_policy_link,
      privacy_policy_link_text: this.state.privacy_policy_link_text,
      errors: this.state.errors || Immutable.Map(),
      isAffiliate: this.props.is_affiliate,
      timer: this.renderTimer(),
    };
  },

  propsForGuestInformation() {
    const {
      fields,
      priceFields,
      zero_priced_tour: zeroPricedTour,
      paid_in_cash: paidInCash,
      ticketUnits,
    } = this.state;
    const { integration_brand_color } = this.props.partner_info;
    const { first_name: firstName, last_name: lastName } = fields.toJS();
    const bookerGuestName = formatBookerGuestName({ firstName, lastName });
    return {
      priceProps: _.extend({}, priceFields.toJS(), {
        calculated: true,
        selected_addons: fields.get('addons'),
        zero_priced_tour: zeroPricedTour,
      }),
      paid_in_cash: paidInCash,
      additionalGuestProps: {
        bookerGuestName,
        numOfGuests: this.getNumGuests(),
        collectGuestInfo: this._collectGuestInfoEnabled(),
        additionalGuestInputChanged: this._additionalGuestInputChanged,
        additionalGuests: this.props.initial_fields.additional_guests,
        units: ticketUnits,
        unitsLoaded: this._unitsLoaded(),
        brandColor: integration_brand_color,
      },
      timer: this.renderTimer(),
    };
  },

  propsForCheckoutSummary() {
    return {
      guideName: this.props.tour.guide_name,
      summary_props: _.extend({}, this.state.summary_props.toJS()),
      booking_request_id: this.state.booking_request_id,
      includes_transport: this.props.includes_transport,
      privacy_policy_link: this.state.privacy_policy_link,
      privacy_policy_link_text: this.state.privacy_policy_link_text,
      confirmation_subtext: this.props.confirmation_subtext,
      onCommit: this.onCommit,
      is_booking_invoice: this.props.is_booking_invoice,
      requiresAuth: this.state.requiresAuth,
      authCompleted: this.state.authCompleted,
      stripeToken: this.state.stripeToken,
      stripeCardElement: this.state.stripeCardElement,
      paymentId: this.state.paymentId,
      customerSecret: this.state.customerSecret,
      errors: this.state.errors,
      timer: this.renderTimer({ marginBottom: '32px' }),
    };
  },

  propsForCheckoutPersonal() {
    const unitPrices = this.gracefulUnitPrices();
    const unitPrice = unitPrices.items?.[0].unit_price;

    return {
      priceProps: _.extend({}, this.state.priceFields.toJS(), {
        calculated: true,
        selected_addons: this.state.fields.get('addons'),
        zero_priced_tour: this.state.zero_priced_tour,
        paid_in_cash: this.state.paid_in_cash,
        cashTotal: this.state.cashTotal,
        onlineTotal: this.state.onlineTotal,
      }),
      fieldsToHide: this._fieldsToHide(),
      can_be_paid_in_cash: this.props.can_be_paid_in_cash,
      booking_request_id: this.state.booking_request_id,
      paid_in_cash: this.state.paid_in_cash,
      loading: this.state.loading,
      guideName: this.props.tour.guide_name,
      phoneMandatory: this.props.phone_mandatory,
      has_resource: this.props.has_resource,
      resource_name: this.props.resource_name,
      fieldRequirementsSubtext: this.props.field_requirements_subtext,
      emailSubtext: this.props.email_subtext,
      phoneSubtext: this.props.phone_subtext,
      is_booking_invoice: this.props.is_booking_invoice,
      countryCode: this.props.initial_fields.billing_country,
      guests: this.getNumGuests(),
      unitPrice,
      currency: this.state.currency,
      shouldCollectGuestInfo: this._shouldCollectGuestInfo(),
      timer: this.renderTimer(),
      unitPriceForInitialPricing: this.state.unitPriceForInitialPricing,
      totalWithoutServiceFee: this.state.totalWithoutServiceFee,
    };
  },

  getSharedProps() {
    return {
      tour: this.props.tour,
      tour_id: this.props.tour_id,
      pluginSlug: this.props.plugin_slug,
      loading: this.state.loading,
      saved: this.state.saved,
      committed: this.state.committed,
      forInvoice: this.state.for_invoice, // here - check again need invoiceable?
      fieldsToHide: this._fieldsToHide(),
      shouldShowAdditionalInformation: this._shouldShowAdditionalInfo(),
      shouldCollectGuestInfo: this._shouldCollectGuestInfo(),
      total: this.state.total,
      guests: this.props.initial_fields.guests,
      has_resource: this.props.has_resource,
      resource_name: this.props.resource_name,
      isAffiliate: this.props.is_affiliate,
      is_ga4_enabled: this.props.is_ga4_enabled,
      currency: this.state.currency,
      unitPriceForInitialPricing: this.state.unitPriceForInitialPricing,
      totalWithoutServiceFee: this.state.totalWithoutServiceFee,
      units_and_addons_detail: this.state.units_and_addons_detail,
      waitlistDetails: this.props.waitlist_details,
      initial_ticket_quantity: this.props.initial_ticket_quantity,
      has_ticket_capacity_enabled: this.props.has_ticket_capacity_enabled,
    };
  },

  getScreenProps(_component, storeProps) {
    let screenProps;
    const component = _component.split('.').pop();
    const screenPropsHandler = `propsFor${component}`;

    if (typeof this[screenPropsHandler] === 'function') {
      screenProps = this[screenPropsHandler]();
    }

    return this._formProxyProps(
      component,
      _.extend(this.getSharedProps(), storeProps, screenProps)
    );
  },

  _renderLogo() {
    const styling = { textAlign: 'center', paddingBottom: '30px' };
    return (
      <span style={styling}>
        <PoweredBy hidePolicyLinks={this.state.hide_policy_links} />
      </span>
    );
  },

  _collectGuestInfoEnabled() {
    const totalUnits = this.state.fields
      .get('units')
      .reduce((a, e) => a + e.count, 0);
    return totalUnits > 1 && this.props.is_guest_of_guest_enabled;
  },

  _shouldRenderLogo() {
    const activeScreen = this.state.activeScreen.get('component');
    const initialBookingsScreen =
      'Views.Plugins.Checkout.Mobile.Screens.BookingInitial';
    const bookingAddonsScreen =
      'Views.Plugins.Checkout.Mobile.Screens.BookingAddons';

    if (
      activeScreen === initialBookingsScreen ||
      activeScreen === bookingAddonsScreen
    ) {
      return false;
    }

    return true;
  },

  loadAPIDates(tourId, locationId) {
    TourAvailabilityActionCreator.loadAPIDates(tourId, locationId, () => {
      this.setState({
        fields: this.state.fields.set('date', null).set('time', null),
      });
    });
  },

  _unitsLoaded() {
    return (
      this.state.ticketUnits &&
      Array.isArray(this.state.ticketUnits) &&
      this.state.ticketUnits.length > 0
    );
  },

  _setInitialPaymentType() {
    const { is_pay_later_enabled } = this.props;
    const { isOutsidePayLaterCutoff } = this.state;
    const selectedPaymentType =
      is_pay_later_enabled && isOutsidePayLaterCutoff
        ? 'pay-later'
        : 'charge-card';

    this._onSelectPaymentType(selectedPaymentType);
  },

  _onSelectPaymentType(paymentType) {
    const fields = this.state.fields.toJS();
    const errors = this.state.errors.toJS();
    const isPayLaterSelected = paymentType === 'pay-later';
    fields.is_pay_later_selected = isPayLaterSelected;

    const paymentSections = this.formSections.CheckoutPayment;
    paymentSections.forEach((ps) => delete errors[ps]);

    this.setState({
      fields: Immutable.Map(fields),
      errors: Immutable.Map(errors),
      selectedPaymentType: paymentType,
      isPayLaterSelected,
    });
  },

  _paymentSubtext() {
    const { isPayLaterSelected } = this.state;

    if (isPayLaterSelected) {
      return null;
    }
    return <p className="form-details">{t('PCI_INFO')}</p>;
  },

  render() {
    return (
      <div className="CheckoutNavigationController">
        <Dimmer loader fixed active={this.state.loading} />
        {this.renderTransitionableScreens()}
        {this._shouldRenderLogo() && this._renderLogo()}
      </div>
    );
  },
});

export default CheckoutNavigationController;
